<div class="flex gap8">
    <product-delivery-state class="flex-span-1 noShrink"
                            [variant]="'PLP'"
                            [product]="product"
                            [qty]="qty"
                            [reducedSize]="true"
                            (onsubmit)="addToDelivery($event.status)"></product-delivery-state>
    <product-collection-state class="flex-span-1 noShrink"
                              [product]="product"
                              [variant]="'PLP'"
                              [qty]="qty"
                              [reducedSize]="true"
                              (onsubmit)="addToCollection($event.status, $event.branchNumber)"></product-collection-state>
</div>